import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { selectBasicFontTheme } from "../selectV2Theme";
import { SelectPlaceholderStyled } from "./SelectPlaceholderStyled";
export const SelectPlaceholder = _ref => {
  let {
    children,
    hasContentBefore,
    ...rest
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(SelectPlaceholderStyled, _extends({
    themeMode: themeMode
    // @ts-expect-error variant type is complaining
    ,
    variant: selectBasicFontTheme.variant(themeMode),
    lineClamp: 1,
    "aria-hidden": true,
    hasContentBefore: hasContentBefore
  }, rest), children);
};
//# sourceMappingURL=SelectPlaceholder.js.map